import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";
import "./Search.css";

const Search = ({ searchData, onSearchResults }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.trim()) {
      performSearch(value);
    } else {
      onSearchResults(searchData);
    }
  };

  const performSearch = (query) => {
    const results = searchData.filter((item) =>
      item.title.toLowerCase().includes(query.toLowerCase())
    );
    onSearchResults(results);
  };

  return (
    <div className="search-container">
      <div className="search-input-wrapper">
        <FiSearch className="search-icon" />
        <input
          type="text"
          placeholder="Search anime..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="search-input"
        />
      </div>
    </div>
  );
};

export default Search;
